export default __webpack_public_path__ + "media/images/portfolio/width-600/portfolio-4-bcb7b74fc046996a53985fe8ff22ffcc.jpg";